import {convertFileToBase64} from "./convert-file-to-base64";

/**
 * For posts update only, convert uploaded image in base 64 and attach it to
 * the `picture` sent property, with `src` and `title` attributes.
 */
export const addUploadCapabilities = requestHandler => (type, resource, params) => {
    if (type === 'UPDATE'  || type === 'CREATE' ) {
        if (params.data.poster && params.data.poster.rawFile instanceof File ) {
            console.log("POSTER UPDATE!!!!");
            return convertFileToBase64(params.data.poster)
                .then(picture64 => ({
                    src: picture64,
                    title: `${params.data.title}`,
                }))
                .then(transformedNewPoster => requestHandler(type, resource, {
                    ...params,
                    data: {
                        ...params.data,
                        poster: transformedNewPoster,
                    },
                }));
        }
    }

    if (type === 'UPDATE' || type === 'CREATE') {
        if (params.data.artwork && params.data.artwork.length) {
            // only freshly dropped pictures are instance of File
            const formerPictures = params.data.artwork.filter(p => !(p.rawFile instanceof File));
            const newPictures = params.data.artwork.filter(p => p.rawFile instanceof File);

            return Promise.all(newPictures.map(convertFileToBase64))
                .then(base64Pictures => base64Pictures.map(picture64 => ({
                    src: picture64,
                    title: `${params.data.title}`,
                })))
                .then(transformedNewPictures => requestHandler(type, resource, {
                    ...params,
                    data: {
                        ...params.data,
                        artwork: [...transformedNewPictures, ...formerPictures],
                    },
                }));
        }
    }


    if (type === 'UPDATE' || type === 'CREATE') {
        if (params.data.photos && params.data.photos.length) {
            console.log("Photos update");
            // only freshly dropped pictures are instance of File
            const formerPictures = params.data.photos.filter(p => !(p.rawFile instanceof File));
            const newPictures = params.data.photos.filter(p => p.rawFile instanceof File);

            return Promise.all(newPictures.map(convertFileToBase64))
                .then(base64Pictures => base64Pictures.map(picture64 => ({
                    src: picture64,
                    title: `${params.data.title}`,
                })))
                .then(transformedNewPictures => requestHandler(type, resource, {
                    ...params,
                    data: {
                        ...params.data,
                        photos: [...transformedNewPictures, ...formerPictures],
                    },
                }));
        }
    }

    return requestHandler(type, resource, params);
};
